class UndoRedoOps {
	#ops;
	#currentState;
	#activeSlide;
	constructor() {
		this.#ops = [];
		this.#currentState = -1;
		this.#activeSlide = null;
	}

	#slideOps = {
		addSlide: "Add",
		updateSlide: "Update",
		deleteSlide: "Delete",
	};

	get length() {
		return this.#ops.length;
	}

	get slideOps() {
		return this.#slideOps;
	}

	get currentState() {
		return this.#currentState;
	}

	set currentState(state) {
		this.#currentState = state;
	}

	#push = (ops) => {
		let lastIndex = this.length - 1;
		let currentIndex = this.currentState;
		if (currentIndex < lastIndex) {
			this.#splice(currentIndex + 1);
		}
		if (
			JSON.stringify(ops) === JSON.stringify(this.#ops[this.length - 1])
		) {
			return;
		}
		this.currentState++;
		return this.#ops.push(ops);
	};

	#pop = () => {
		return this.#ops.pop();
	};

	#splice = (index) => {
		this.#ops.splice(index);
	};

	#canUndo = () => {
		let index = this.currentState;
		let lastIndex = this.length - 1;
		if (index >= 0 && lastIndex >= 0 && index <= lastIndex) return true;
		return false;
	};

	#canRedo = () => {
		let index = this.currentState;
		let lastIndex = this.length - 1;
		if (index >= -1 && lastIndex >= 0 && index < lastIndex) return true;
		return false;
	};

	reset = () => {
		this.#ops = [];
		this.#currentState = -1;
		this.#activeSlide = null;
	};

	undo = () => {
		if (!this.#canUndo()) {
			return false;
		}
		let ops = { ...this.#ops[this.currentState] };
		if (
			ops.action === this.slideOps.updateSlide &&
			this.currentState <= 0
		) {
			return false;
		}
		if (this.currentState > 0) {
			if (
				ops.action !== this.slideOps.deleteSlide &&
				JSON.stringify(ops.slide) ===
					JSON.stringify(this.#ops[this.currentState - 1].slide) &&
				this.#ops[this.currentState - 1].action ===
					this.slideOps.addSlide
			) {
				this.currentState--;
				ops = { ...this.#ops[this.currentState] };
			}
		}
		switch (ops.action) {
			case this.slideOps.addSlide:
				ops.action = this.slideOps.deleteSlide;
				break;

			case this.slideOps.deleteSlide:
				ops.action = this.slideOps.addSlide;
				break;

			case this.slideOps.updateSlide:
				ops = { ...this.#ops[this.currentState - 1] };
				break;

			default:
				return false;
		}
		this.currentState--;
		return ops;
	};

	redo = () => {
		if (!this.#canRedo()) {
			return false;
		}
		this.currentState++;
		let ops = { ...this.#ops[this.currentState] };
		if (this.currentState > 0)
			if (
				JSON.stringify(ops.slide) ===
					JSON.stringify(this.#ops[this.currentState - 1].slide) &&
				this.length - 1 > this.currentState
			) {
				this.currentState++;
				ops = { ...this.#ops[this.currentState] };
			}
		return ops;
	};

	updateActiveSlide = (slide) => {
		if (slide) {
			this.#activeSlide = { ...slide };
		}
	};

	addSlide = (slide, index) => {
		let ops = {
			action: this.slideOps.addSlide,
			slide,
			index,
		};
		return this.#push(ops);
	};

	deleteSlide = (slide, index) => {
		let ops = {
			action: this.slideOps.deleteSlide,
			slide,
			index,
		};

		return this.#push(ops);
	};

	updateSlide = (slide) => {
		let ops = {
			action: this.slideOps.updateSlide,
			slide,
		};
		if (!!this.#activeSlide) {
			if (this.#activeSlide.id === slide.id) {
				this.#push({
					...ops,
					slide: { ...this.#activeSlide },
				});
			}
			this.#activeSlide = null;
		}
		return this.#push(ops);
	};
}

export const UndoRedo = (() => {
	let instance = null;
	if (instance === null) {
		instance = new UndoRedoOps();
	}
	return instance;
})();
